<!-- 租约详情 -->
<template>
    <div id="leaseDetail">
      <div v-if="!editMode" class="operationDiv">
        <div>
          <pt-tag v-if="leaseVO.type == 2" :text="$t('lease.detail.turnPursuits')" type="triangle"></pt-tag>
          <pt-tag v-if="leaseVO.type == 1" :text="$t('lease.detail.turnDeal')" type="triangle"></pt-tag>
        </div>
        <div class="topRow" v-if="showTopButton && !stockLease && !searchOverallFlag">
          <div  style="display:flex;flex-direction: row">
            <a-button :loading="emptyLoading" v-if="leaseVO.vacantStatus == 1" @click.stop="changeVacantStatus">
              <pt-icon type="icon-kongzhimianji1"></pt-icon>
              {{$t('lease.detail.willEmpty')}}
            </a-button>
            <a-button @click.stop="turnToTrack" v-if="!(leaseVO.type == 1 || leaseVO.type == 2)">
              <pt-icon type="icon-zhuizongsuyuan"></pt-icon>
              {{$t('lease.detail.turnToPursuits')}}
            </a-button>
            <a-button @click.stop="turnToDeal" v-if="!(leaseVO.type == 1 || leaseVO.type == 2)">
              <pt-icon type="icon-jiaoyiku1"></pt-icon>
              {{$t('lease.detail.turnToDeal')}}
            </a-button>
            <a-button @click.stop="deleteLease" v-if="!(leaseVO.type == 1 || leaseVO.type == 2)">
              <pt-icon type="icon-tubiao"></pt-icon>
              {{$t('baseVO.delete')}}
            </a-button>
            <a-button @click.stop="editEvent">
              <pt-icon type="icon-bianji1"></pt-icon>
              {{$t('baseVO.edit')}}
            </a-button>
          </div>
        </div>
      </div>
      <div v-if="editMode" class="topRow">
        <a-button type="primary" style="margin-right: 10px;" @click.stop="saveEdit">{{$t('baseVO.save')}}</a-button>
        <a-button @click.stop="cancelEdit">{{$t('baseVO.cacel')}}</a-button>
      </div>

      <div v-if="!editMode">
        <div style="padding: 35px 40px;">
          <div class="companyDiv">
<!--            <div class="companyLogo">-->
<!--              <img v-if="leaseVO.companyLogo !='0'" :src="getImageUrl()" alt="">-->
<!--              <img  v-else src="../../../../assets/defulat/company.png"/>-->
<!--            </div>-->
            <div class="companyNameDiv">
              <div class="nameText">{{leaseVO.companyName}}</div>
              <div>
                <span class="infoLabel" style="margin-right: 4px;">{{$t('lease.modal.trade')}}:</span>
                <span class="infoText">{{leaseVO.tradeName}}</span>
              </div>
            </div>
            <div>
              <div @click="viewCompany" style="width: 24px;height: 24px;">
                <pt-icon type="icon-xiangqingcopy" class="viewIcon" :title="$t('lease.modal.viewCustomer')"></pt-icon>
              </div>
            </div>
          </div>
          <div class="greyDiv">
            <div style="width:250px;">
              <div class="infoLabel">{{$t('lease.modal.signTime')}}</div>
              <div class="infoText">{{leaseVO.signTime | dayjs('YYYY-MM')}}</div>
            </div>
            <div style="width:250px;">
              <div class="infoLabel">{{$t('lease.detail.rentDate')}}</div>
              <div class="infoText">
                <template v-if="leaseVO.startTime != '~' || leaseVO.endTime != '~'">
                  {{leaseVO.startTime == '~'?'~':$utils.format(leaseVO.startTime,'YYYY-MM')}} {{ $t('keyzhi') }} {{leaseVO.endTime == '~'?'~':$utils.format(leaseVO.endTime,'YYYY-MM')}}
                </template>
                <template v-else>~</template>
              </div>
            </div>
            <div>
              <div class="infoLabel">{{$t('lease.modal.successBy')}}</div>
              <div class="infoText">{{leaseVO.agentName}}</div>
            </div>
          </div>
          <div class="greyDiv">
            <div style="width:250px;">
              <div class="infoLabel">{{$t('lease.modal.rent')}}({{leaseVO.rentUnitStr}})</div>
              <div class="infoText">{{leaseVO.rent}}</div>
            </div>
            <div style="width:250px;">
              <div class="infoLabel">{{$t('lease.detail.rate')}}</div>
              <div class="infoText">{{leaseVO.dueDatePrice}}<span v-if="leaseVO.increasing != '~'">%</span></div>
            </div>
            <div>
              <div class="infoLabel">{{$t('lease.modal.freeRent')}}</div>
              <div class="infoText">{{leaseVO.rentFreePeriod}}</div>
            </div>
          </div>
          <div class="mansionDiv">
            <div class="mansionLeft">
              <div class="mansionLabelRow">
                <div class="mansionLabel" style="width: 30%;text-align: center;">{{$t('deal.addDeal.leaseContract.mansionName')}}</div>
                <div class="mansionLabel" style="width: 25%;padding-left: 20px;">{{$t('deal.addDeal.leaseContract.floor')}}</div>
                <div class="mansionLabel" style="width: 25%;">{{$t('deal.addDeal.leaseContract.unitCode')}}</div>
                <div class="mansionLabel" style="width: 20%;">{{$t('deal.addDeal.leaseContract.area')}}</div>
              </div>
              <div style="display: flex;flex-direction: row;padding-top: 10px;">
                <div class="mansionImg" style="display: flex; align-items: center;">
                  <!--<img v-if="leaseVO.mansionHeadImg != '0'" :src="getMansionUrl(leaseVO.mansionHeadImg)"/>-->
                  <!--<img v-else src="../../../../assets/defulat/mansion.png"/>-->
                  <div class="mansionInfoText">{{leaseVO.mansionName}}</div>
                </div>
                <div class="floors" style="width: 70%;">
                  <div  v-for="(floor,index) in leaseVO.leaseLeaseInfoDetailsVOList":key="index" class="mansionInfoRow">
                    <div class="mansionInfoText" style="padding-left: 20px;width: 35%;">{{floor.floorNum}}</div>
                    <div class="mansionInfoText" style="width: 35%;">{{floor.unitCodes}}</div>
                    <div class="mansionInfoText" style="width: 30%;">
                      {{floor.areaSizeStr}}{{leaseVO.areaUnitStr}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mansionRight">
              <div class="mansionRightRow">{{$t('deal.addDeal.leaseContract.totalArea')}}</div>
              <div class="totalAreaDiv">
                {{leaseVO.leaseArea}}{{leaseVO.areaUnitStr}}
              </div>
            </div>
          </div>
          <div class="greyDiv" v-if="false">
            <div>
              <div class="infoLabel">{{$t('lease.modal.opponent')}}</div>
              <div class="infoText" style="display: flex;flex-direction: row" v-if="leaseVO.colleagueDOS != null">
                <div v-for="(colleagueDO,index) in leaseVO.colleagueDOS">
                  <span v-if="index == 0">{{colleagueDO.companySortNameEn}}</span>
                  <span v-else>,{{colleagueDO.companySortNameEn}}</span>
                </div>
              </div>
              <div class="infoText" style="display: flex;flex-direction: row" v-else>
                ~
              </div>
            </div>
          </div>
          <div class="remarksDiv">
            <div class="infoLabel">{{$t('lease.modal.remarks')}}</div>
            <div class="remarksText">{{leaseVO.remarks}}</div>
          </div>
        </div>
        <div class="filesDiv">
          <div class="titleRow">
            <div class="circleYellow"></div>
            <div class="titleText">{{$t('lease.modal.files')}}</div>
          </div>
          <div v-if="leaseVO.leaseAttachmentDOS && leaseVO.leaseAttachmentDOS.length > 0" style="padding:10px;">
            <div v-for="(item,index) in leaseVO.fileDOList" :key="index" class="fileItem">
              <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
              <div class="fileName">{{item.fileName}}</div>
              <div @click="previewFile(item)"  v-if="$util.matchPreviewType(item.fileName)" style="margin-right: 20px;">
                <pt-icon class="downloadIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
              </div>
              <div @click="downloadFile(item)" style="margin-right: 20px;">
                <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
              </div>
              <div @click="deleteFile(item.id)">
                <pt-icon class="downloadIcon" type="icon-tubiao" :title="$t('baseVO.delete')"></pt-icon>
              </div>
            </div>
          </div>
          <div v-else class="noFileClass">
            <pt-empty><span slot="description">{{$t('leaveRecords.tips.emptyFile')}}</span></pt-empty>
          </div>
        </div>
      </div>
      <div v-if="editMode" style="padding: 40px;">
        <add-lease :leaseId="leaseId" ref="addLease" @saveSuccess="saveSuccess"></add-lease>
      </div>
      <pt-modal :title="$t('lease.detail.dealTitle')" :visible="dealModal.visible" :loading="dealModal.loading" @ok="addDeal"
                @cancel="cancelAddDeal">
        <div slot="content">
          <add-deal :leaseVO="leaseVO" ref="addDeal" @saveSuccess="saveDealSuccess" @validateFail="validateFail"></add-deal>
        </div>
      </pt-modal>
      <pt-modal :title="$t('lease.detail.trackTitle')" :width="800" :visible="trackModal.visible" :loading="trackModal.loading" @ok="addTrack"
                @cancel="cancelAddTrack">
        <div slot="content">
          <issue-track :leaseVO="leaseVO" ref="issueTrackRef"  @saveSuccess="saveTrackSuccess" @error="saveError"></issue-track>
        </div>
      </pt-modal>
      <pt-modal :z-index="9999999" :title="$t('customer.customerDetail.title')" :visible="customerModelVisible"  :footer="true"  @cancel="closeCustomerModel">
        <div slot="content">
          <customer-info :customerVO="customerVO" :show-linkman-detail="false"></customer-info>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import AddLease from './addLease'
  import AddDeal from '../../../mine/deal/addDeal'
  import IssueTrack from '../../../mine/pursuits/module/issueTrack'
  import leaseApi from '@/api/database/lease'
  import leaseAttachmentApi from '@/api/database/leaseAttachment'
  import CustomerInfo from '../../customer/module/customerInfo'
  import {selectOne} from '@/api/mine/customer'
  export default {
    name: 'leaseDetail',
    components: { CustomerInfo, IssueTrack, AddDeal, AddLease },
    props:{
      leaseId:null,
      stockLease:false,
      showTopButton:{
        type: Boolean,
        default: true
      },
      searchOverallFlag:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        emptyLoading:false,
        editMode:false,
        dealModal:{
          visible:false,
          loading:false,
        },
        trackModal:{
          visible:false,
          loading:false,
        },
        leaseVO:{},
        customerVO:{},
        customerModelVisible:false,
      }
    },
    mounted(){
      this.init()
    },
    computed:{
      areaUnit(){
        if(this.leaseVO.leaseLeaseInfoDetailsVOList){
          if(this.leaseVO.leaseLeaseInfoDetailsVOList.length > 0){
            return this.leaseVO.leaseLeaseInfoDetailsVOList[0].areaSizeUnit
          }
        }
      },
      totalAreaSize(){
        if(this.leaseVO.leaseLeaseInfoDetailsVOList){
          if(this.leaseVO.leaseLeaseInfoDetailsVOList.length > 0){
            let total = 0
            this.leaseVO.leaseLeaseInfoDetailsVOList.forEach(e=>{
              total += e.areaSize
            })
            return total
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
    },
    methods:{
      getMansionUrl(fileId){
        let url = this.$util.getFileUrl(fileId);
        return url;
      },
      viewCompany(){
        this.customerModelVisible = true;
      },
      closeCustomerModel(){
        this.customerModelVisible = false;
      },
      saveTrackSuccess(){
        this.cancelAddTrack();
        this.queryDetail();
        this.$emit("freshLeaseList");
      },
      saveDealSuccess(){
        this.cancelAddDeal();
        this.queryDetail();
        this.$emit("freshLeaseList");
      },
      changeVacantStatus(){
        this.emptyLoading = true;
        leaseApi.updateLeaseInfoStatus(this.leaseId,2).then(res => {
          if (res.code == 1) {
            this.emptyLoading = false;
            this.$emit("updateStatusSuccess");
            this.$message.success(this.$t('lease.detail.updateSuccess'));
            this.queryDetail();
          }
        })
      },
      deleteFile(fileId){
        leaseAttachmentApi.deleteObj(fileId).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('lease.detail.deleteFileSuccess'));
            this.queryDetail();
          }
        })
      },
      deleteLease(){
        let _this = this
        this.$ptConfirm({
          title: this.$t('lease.delete.title'),
          content: this.$t('lease.delete.content'),
          okType: 'primary',
          onOk() {
            _this.execDelete()
          },
          onCancel() {

          },
        })

      },
      execDelete(){
        leaseApi.deleteObj(this.leaseId).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('lease.detail.deleteFileSuccess'));
            this.$emit("deleteSuccess")
            this.$drawer.drawerInfoClose()
          }
        })
      },
      uploadSuccess(file,fileId){
        let leaseAttachmentDO = {
          leaseId:this.leaseId,
          fileId:fileId
        }
        this.saveLeaseAttachmentDO(leaseAttachmentDO);
      },
      saveLeaseAttachmentDO(data){
        leaseAttachmentApi.insert(data).then(res => {
          if (res.code == 1) {
            this.queryDetail();
          }
        })
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.leaseVO.companyLogo);
        return url;
      },
      init(){
        this.queryDetail();
      },
      queryDetail(){
        let this_ = this
        leaseApi.selectOne(this_.leaseId).then(res=>{
          if(res.code == 1){
            this_.leaseVO = res.data
            this.initCustomerDetail(res.data.customerId);
          }
        })
      },
      initCustomerDetail(customerId){
        let that = this;
        selectOne(customerId).then(res=>{
          if(res.code == 1){
            that.customerVO = res.data;
          }
        })
      },
      editEvent(){
        this.editMode = true;
      },
      saveEdit(){
        this.$refs.addLease.submit()
      },
      cancelEdit(){
        this.editMode = false;
      },
      saveSuccess(){
        this.cancelEdit();
        this.queryDetail();
        this.$emit("freshLeaseList");
      },
      previewFile(file){
        this.$util.previewFile(file.id)
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.id,file.fileName,this);
      },
      turnToDeal(){
        this.dealModal.visible = true;
      },
      addDeal(){
        if(!this.dealModal.loading){
          this.dealModal.loading = true;
          this.$refs.addDeal.submit();
        }
      },
      cancelAddDeal(){
        this.dealModal.visible = false;
        this.dealModal.loading = false;
      },
      validateFail(){
        this.dealModal.loading = false;
      },
      turnToTrack(){
        this.trackModal.visible = true;
      },
      addTrack(){
        if(!this.trackModal.loading){
          this.trackModal.loading = true;
          this.$refs.issueTrackRef.getData();
        }
      },
      cancelAddTrack(){
        this.trackModal.visible = false;
        this.trackModal.loading = false;
      },
      saveError(){
        this.trackModal.loading = false;
      }
    }
  }
</script>

<style scoped lang="less">
  #leaseDetail{
    .mansionDiv{
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 10px;
      .mansionLeft{
        width: 70%;
        display: flex;
        flex-direction: column;
        margin-right: 5px;
        padding: 10px;
        background: #FAFBFC;
      }
      .mansionLabelRow{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #EEEEEE;
        padding-bottom: 10px;
      }
      .mansionLabel{
        font-size: 12px;
        color: #999999;
      }
      .mansionImg{
        img{
          width: 40px;
          height: 40px;
        }
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #EEEEEE;
      }
      .floors{
        flex: 1;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .mansionInfoRow{
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid #EEEEEE;
      }
      .mansionInfoRow:last-child{
        border-bottom: 0;
      }
      .mansionInfoText{
        font-size: 12px;
        color: #333333;
      }
      .mansionRight{
        flex: 1;
        display: flex;
        flex-direction: column;
        //margin-right: 5px;
        padding: 10px;
        background: #FAFBFC;
        .mansionRightRow{
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #EEEEEE;
          padding-bottom: 10px;
        }
        .totalAreaDiv{
          font-size: 16px;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
      }
    }
    .operationDiv{
      background: #FAFBFC;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center
    }
    .topRow{
      height: 50px;
      padding: 0 40px;
      background: #FAFBFC;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .ant-btn{
        margin-left: 15px;
      }
    }
    .companyDiv{
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;
      padding-right: 10px;
      .companyLogo{
        width: 80px;
        margin-right: 30px;
        img{
          width: 100px;height: 100px
        }
      }
      .companyNameDiv{
        flex: 1;
        margin: 0 20px;
        .nameText{
          font-size: 18px;
          color: #333333;
          margin-bottom: 15px;
          font-weight: bold;
        }
      }
    }
    .infoLabel{
      font-size: 12px;
      color: #999999;
    }
    .infoText{
      font-size: 12px;
      color: #333333;
    }
    .greyDiv{
      padding: 15px 20px;
      background: #FAFBFC;
      border-radius: 0 0 4px 4px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
    }
    .rowClass{
      display: flex;
      flex-direction: row;
    }
    .filesDiv{
      padding: 0 40px;
    }
    .titleRow{
      background: #FAFBFC;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 15px;
      .circleYellow{
        width: 12px;
        height: 12px;
        background: #FABE00;
        border-radius: 50%;
        margin: 0 10px;
      }
      .titleText{
        font-size: 14px;
        color: #333333;
      }
    }
    .fileItem{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
      .fileIcon{
        font-size: 18px;
      }
      .fileName{
        flex:1;
        font-size: 12px;
        color: #333333;
        margin: 0 10px;
      }
      .downloadIcon{
        font-size: 16px;
        cursor: pointer;
      }
    }
    .remarksDiv{
      padding: 0 20px;
      .remarksText{
        margin-top: 8px;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
      }
    }
  }
</style>